/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1719
 */

require(/* 86 */"../1650/86/index")({
  target: "String",
  proto: true
}, {
  repeat: require(/* 1092 */"./1092")
})
